export default "__VITE_ASSET__BZFC14LD__"